import React, { useState } from 'react'

export const useActionsCenterView = (initialView) => {
    const [centerView, setCenterView] = useState(initialView ?? 'agenda')
    return [centerView, setCenterView]
}